import { createContext } from "react";
import { UserPermission } from "src/components/types";

type UserContextType = {
  username: string;
  permissions: UserPermission[];
  hasPermission: (permKey: string) => boolean;
};

function hasPermission(permissions: UserPermission[], permKey: string): boolean {
  return permissions.find((permission) => permission.permKey === permKey) !== undefined;
}

export function makeUserContext(username: string, permissions: UserPermission[]): UserContextType {
  return {
    username,
    permissions,
    hasPermission: (permKey: string) => hasPermission(permissions, permKey),
  };
}

export const UserContext = createContext<UserContextType>({
  username: "",
  permissions: [],
  hasPermission: (permKey: string) => hasPermission([], permKey),
});
